module.exports = __webpack_public_path__ + "static/img/sv-4.9341f34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery/sv-4.jpg
// module id = jH/E
// module chunks = 0